import { render, staticRenderFns } from "./formwindow.vue?vue&type=template&id=2ddcfbe2&scoped=true&"
import script from "./formwindow.vue?vue&type=script&lang=js&"
export * from "./formwindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddcfbe2",
  null
  
)

export default component.exports